/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CheckListItemViewModelPaginatedResponse } from "../types/CheckListItemViewModelPaginatedResponse.ts";
import { checkListItemViewModelSchema } from "./checkListItemViewModelSchema.ts";

export const checkListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => checkListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CheckListItemViewModelPaginatedResponse>;
